import { ParsedPioneerText } from "../../types/statistics";

export function parsePioneerText(text: string): ParsedPioneerText {
  const lines = text.split("\n").map((s) => s.trim()).filter(Boolean);
  const result: ParsedPioneerText = {
    therapyArea: "",
    totalTime: "",
    totalScore: "",
  };

  for (const line of lines) {
    if (line.startsWith("Therapy Area:")) {
      result.therapyArea = line.replace("Therapy Area:", "").trim();
    } else if (line.startsWith("Total Time:")) {
      result.totalTime = line.replace("Total Time:", "").trim();
    } else if (line.startsWith("Total Score:")) {
      result.totalScore = line.replace("Total Score:", "").trim();
    } else if (line.startsWith("Proficiency Level:")) {
      const match = line.match(/Proficiency Level:\s*([\d.]+)\s*\/\s*5\.0/);
      result.totalScore = match ? match[1].trim() : "";
    }
  }

  return result;
}
